import { render, staticRenderFns } from "./PreqCourse.vue?vue&type=template&id=3e01b8f5"
import script from "./PreqCourse.vue?vue&type=script&lang=js"
export * from "./PreqCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports